import { ContextEnum } from '../enuns/context.enum';
import environment from '../scripts/environment';

export class LogActionModel {
  system: number  = 2; // System = Neogig
  idSession: string;
  context: string;
  action: string;
  parameters: string;

  constructor(context: ContextEnum, action: string, parameters: string) {
    this.context = context;
    this.action = action;
    this.parameters = parameters;
    this.idSession = environment.get('SESSION_ID');
  }
}



// WEBPACK FOOTER //
// ./src/models/logAction.model.js